<div class="modal-body">
  No Face detected, try again ?
</div>
<div class="modal-footer">
  <button class="btn btn-md btn-primary btn-close btn-santander" (click)="onCloseClicked()">Close</button>
  <button class="btn btn-md btn-primary btn-close btn-santander" (click)="onRetryClicked()">Retry</button>
</div>
